<template>
  <div>
    <v-form ref="form">
      <v-card class="pa-5 pa-sm-10" elevation="0">
        <v-row>
          <v-col>
            <v-row no-gutters align="center">
              <h4 class="greyDark--text font-weight-bold mb-0">
                {{ $t('common:role_plural') }}
              </h4>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs}">
                  <v-btn class="ml-2" icon @click="cardView = !cardView" v-bind="attrs" v-on="on">
                    <v-icon>list_alt</v-icon>
                  </v-btn>
                </template>
                <span v-if="cardView">{{ $t('buttons:table-view') }}</span>
                <span v-else>{{ $t('buttons:card-view') }}</span>
              </v-tooltip>
            </v-row>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="d-none d-md-block">
            <RadialScore ref="roleScore" :score="score" score-icon="role"/>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="text-right">
            <BaseButton
                color="primary"
                :btnText="$t('buttons:add-specific', { specific: $t('common:role')})"
                @clickedButton="$refs.roleForm.addRole(restRolePaginated.options, restRolePaginated.search)"
            />
          </v-col>
          <v-col cols="12" sm="12" class="d-block d-md-none">
            <RadialScore ref="roleScore" :score="score" score-icon="role"/>
          </v-col>
          <v-col cols="12" class="pt-0" v-show="!cardView">

            <DataTablePaginated
                ref="facilityRole"
                :headers="roleHeaders"
                :enabled-search="true"
                @updateTableData="updateRoleTable"
                icon="delete"
                :iconTooltip="$t('buttons:delete')"
                @clickedButton1="deleteUserAssignment"
                checkboxOnProperty="roleConfirmed"
                checkboxOnProperty2="accepted"
                sortBy="userName"
                @cacheCommit="$store.commit('book/facility/storeFacilityRoleSearch', $event)"
                :cachedSearch="$store.state.book.facility.roleSearch"
            />

          </v-col>
        </v-row>

        <div v-show="cardView">
          <SearchAndSortBar
              @updateData="updateRoleTable"
              @cacheCommit="$store.commit('book/facility/storeFacilityRoleSearch', $event)"
              :cachedSearch="$store.state.book.facility.roleSearch"
              class="mb-3"
              :sorts="roleHeaders"
              disable-filter
              default-sort-by="userName"
          />
          <v-row>
            <v-col cols="12" md="6" :lg="cardSize" xl="4" v-for="item in requiredRoles" :key="item.id">
              <ItemCard
                  :item="item"
                  :title="item.name"
                  hideActionBtn1
                  hideActionBtn2
                  hideActionBtn3
                  hideChart
                  hideViewBtn
                  cardElevation
                  @viewItem="setRequiredRole(item)"
                  required
                  :required-btn-text="$t('book/facility:facility.dashboard.information.roles.required-btn')"
                  height="180"
              />
            </v-col>
            <v-col cols="12" md="6" :lg="cardSize" xl="4" v-for="item in restRolePaginated.content" :key="item.id">
              <ItemCard
                  :item="item"
                  :title="item.userName"
                  :subtitle="item.roleName"
                  :description="$t('common:rank') +': '+ item.rank"
                  hideActionBtn1
                  hideActionBtn2
                  hideActionBtn3
                  hideChart
                  hideViewBtn
                  cardElevation
                  showDelete
                  showProfile
                  @deleteItem="deleteUserAssignment(item)"
                  height="180"
                  :was-required="item.wasRequired"
              />
            </v-col>
          </v-row>
          <v-pagination v-show="this.restRolePaginated.content.length != 0"
                        class="mt-3"
                        v-model="restRolePaginated.options.page"
                        :length="totalPages"
                        :total-visible="7">
          </v-pagination>
        </div>
        <v-col v-if="restRolePaginated.content.length == 0 && restRequiredRoles.length == 0" class="text-center">
          <h6 class="greyTint--text mb-0">
            {{ $t('common:no-data-found') }}
          </h6>
        </v-col>

      </v-card>
    </v-form>

    <FacilityRoleDialogForm
        ref="roleForm"
        @updateRoleData="updateRoleTable"
    />

    <TwoButtonDialog
        ref="deleteUserAssignmentButton"
        :btn-text="$t('buttons:delete')"
        color="grey"
        :dialog-title="$t('dialog:delete-btn-title',{name : $t('book/facility:facility.dashboard.information.roles.dialog-part-1')})"
        :dialog-text="$t('dialog:delete-btn-dialog',{name : $t('book/facility:facility.dashboard.information.roles.dialog-part-2')})"
        :button1-text="$t('buttons:cancel')"
        :button2-text="$t('buttons:delete')"
        @clickedButton1="$refs.deleteUserAssignmentButton.showDialog = false"
        @clickedButton2="deleteUserAssignmentConfirmed()"
        hide-button
    />
  </div>
</template>
<script>

import FacilityUserAssignmentService from "@/modules/book/services/facility-user-assignment-service";
import Utils from "@/modules/core/services/utils";
import DataUtils from "@/modules/core/services/data-utils";
import ItemCard from '@/modules/core/components/ItemCard'
import DataTablePaginated from "@/modules/core/components/DataTable/DataTablePaginated";
import FacilityRoleDialogForm from "../formDialogs/FacilityRoleDialogForm"
import TwoButtonDialog from "@/modules/core/components/TwoButtonDialog/TwoButtonDialog";
import BaseButton from "@/modules/core/components/Base/BaseButton";
import SearchAndSortBar from "@/modules/core/components/SearchAndSortBar";
import {mapState} from 'vuex'
import FacilityTypeService from "@/modules/book/services/facility-type-service";
import WorkerRole from "@/modules/core/data/worker-role";
import Score from "@/modules/book/data/score";
import RadialScore from "@/modules/core/components/RadialScore";

export default {
  name: 'FacilityRoleInfoTab',
  components: {
    RadialScore,
    ItemCard,
    DataTablePaginated,
    FacilityRoleDialogForm,
    TwoButtonDialog,
    BaseButton,
    SearchAndSortBar
  },
  data() {
    return {
      cardView: true,
      restRolePaginated: {
        options: [],
        search: [],
        content: []
      },
      totalPages: null,
      restRequiredRoles: [],
      score: new Score()
    }
  },
  computed: {
    roleHeaders() {
      return [
        {text: this.$t("common:role"), value: "roleName"},
        {text: this.$t("common:name"), value: "userName"},
        {text: this.$t("common:rank"), value: "rank"},
        {text: this.$t("book/facility:facility.dashboard.information.roles.table.col-5"), value: "checkbox2"},
        {text: "", value: "controls"},
      ];
    },
    cardSize() {
      //if both sidebars are fully opened, make card size bigger
      if (this.leftFacilityDrawer && this.rightFacilityDrawer) {
        return '6'
        // if both side bars are closed, make card size smaller
      } else if (!this.leftFacilityDrawer && !this.rightFacilityDrawer) {
        return '4'
      } else {
        return '6'
      }
    },

    ...mapState('book/layout', {
      leftFacilityDrawer: state => state.leftFacilityDrawer,
      rightFacilityDrawer: state => state.rightFacilityDrawer
    }),

    requiredRoles() {
      if (this.restRolePaginated.options.page === 1) {
        return this.restRequiredRoles;
      } else {
        return []
      }
    }
  },
  methods: {
    updateRoleTable(options, search) {
      this.restRolePaginated.options = options;
      this.restRolePaginated.search = search;

      if (!search) search = '';

      if (!this.cardView) {
        this.$refs.facilityRole.loading = true;
      }

      FacilityUserAssignmentService.readFacilityUserAssignmentsForFacilityPaginated(
          this.$route.params.id,
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (res) => {

            if (!this.cardView) {
              this.$refs.facilityRole.fillTableData(res.data);
              this.$refs.facilityRole.loading = false;
            } else {
              this.restRolePaginated.content = res.data.content;
              this.getRequiredRoles();
              this.totalPages = res.data.totalPages;
            }

            this.getScore();
            this.$emit('updateQuicklinkRoles')
          },
          (error) => {
            if (!this.cardView) {
              this.$refs.facilityRole.loading = false;
            }
            this.$logger.error("Error at fetching facility contracts: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:contract.snackbar.contract')}))
          }
      )
    },

    deleteUserAssignment(item) {
      this.deleteUserAssignmentId = item.id;
      this.$refs.deleteUserAssignmentButton.showDialog = true;
    },
    deleteUserAssignmentConfirmed() {
      FacilityUserAssignmentService.deleteFromAPI(this.deleteUserAssignmentId,
          () => {
            this.updateRoleTable(this.restRolePaginated.options, this.restRolePaginated.search);
            Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('book/facility:facility.snackbar:assignment')}));
          },
          (error) => {
            this.$logger.error("Failed to delete user assignment, because: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('book/facility:facility.snackbar:assignment')}))
          }
      )
      this.$refs.deleteUserAssignmentButton.showDialog = false;
    },

    setRequiredRole(item) {
      this.$refs.roleForm.data.role = item.id;
      this.$refs.roleForm.addRole(this.restRolePaginated.options, this.restRolePaginated.search);
    },

    getRequiredRoles() {
      FacilityTypeService.readRequiredRolesForFacilityFromAPI(this.$route.params.id,
          (resp) => {
            this.restRequiredRoles = DataUtils.parseDataToObjectArray(resp.data, WorkerRole);
          }
      )
    },

    getScore() {
      FacilityUserAssignmentService.readFacilityUserAssignmentScoreForFacility(this.$route.params.id,
          (res) => {
            this.score = DataUtils.parseDataToSingleObject(res.data, Score);
            this.$emit("updateRoleScore", this.score.percentage);
          }
      )
    }
  },
  watch: {
    cardView() {
      this.updateRoleTable(this.restRolePaginated.options, this.restRolePaginated.search);
    }
  }
}
</script>
